import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { FOOD_MOODS_QUERY } from '../graphql/queries'
import { FETCH_FOOD_MOODS } from '../redux/action-types'
import { cleanupFetchFoodMoods } from '../redux/actions'

const useFoodMoodsQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchFoodMoods)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.foodMoods.foodMoods,
  )

  const refetch = useCallback(
    () => apolloService.query(FOOD_MOODS_QUERY, {}, dispatch, FETCH_FOOD_MOODS),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useFoodMoodsQuery
